import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    row: {
      display: "flex",
      marginBottom: theme.spacing(1),
      "&:last-child": {
        marginBottom: 0,
      },
    },
    left: {
      width: 150,
    },
    right: {
      flex: 1,
    },
    notes: {
      maxHeight: 300,
      overflowY: "auto",
    },
  })
);
